import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './not-found-404.module.scss'

export function NotFound404Page() {    
    const { t } = useTranslation()
    return (
            <div className={styles.content}>
                <div className={styles.header}>
                    <div className={styles.gradient}></div>
                    <div className={styles.name}>{t('not-found-404.pageNotFound')}</div>
                </div>
            </div>
    )
}
